import { ReminderEmailsSectionCombinedProps } from './types';

const usePresenter = (props: ReminderEmailsSectionCombinedProps): ReminderEmailsSectionCombinedProps => {
  return props;
};

export default usePresenter;
